<template>
    <div>
        <button type="button" class="btn btn-primary btn-icon" v-if="this.$config.view === 'button'" @click.prevent="onProductAdd(this.$config.id)"><span>Add to Cart</span>
            <i v-if="loading"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></i>
            <i v-else class="icon-shopping-bag"></i>
        </button>

        <div class="add-to-cart-container" v-if="this.$config.view === 'full'">
            <div class="add-to-cart-sticky">
                <ReadingProgressBar />

                <div class="add-to-cart add-to-cart--row container-xxl">
                    <SectionNavigation class="add-to-cart__navigation" />

                    <div class="add-to-cart__cart">
                        <div class="add-to-cart__price">
                            <div class="add-to-cart__price-final">
                                <div class="add-to-cart__price-value">
                                    {{ formFinalPrice }}
                                </div>

                                <div class="add-to-cart__price-info">per license, VAT incl.</div>
                            </div>

                            <div class="add-to-cart__price-original" v-if="formOriginalPrice || formRuleFormat">
                                <div class="add-to-cart__price-badge" v-if="formRuleFormat">
                                    <span class="badge badge-sm rounded-pill text-bg-secondary">save {{ formRuleFormat }}</span>
                                </div>

                                <div class="add-to-cart__price-value-original" v-if="formOriginalPrice">
                                    {{ formOriginalPrice }}
                                </div>
                            </div>
                        </div>

                        <div class="widget-quantity">
                            <div class="add-to-cart__quantity">
                                <select
                                    v-model.number.lazy="formQuantity"
                                    v-if="formQuantity <= maxPredefinedQuantity"
                                    aria-label="Quantity">
                                    <option v-for="quantity in predefinedQuantities" :value="quantity.value">{{ quantity.label }}</option>
                                </select>
                                <input type="number"
                                       v-model.number.lazy="formQuantity"
                                       @blur="normalizeQuantityInput($event.target)"
                                       class="form-control"
                                       aria-label="Quantity"
                                       v-else>
                            </div>

                            <button @click="onProductAdd(this.$config.id)" class="add-to-cart__button btn btn-primary"><i class="icon-shopping-bag d-md-none"><span class="visually-hidden">Add to Cart</span></i><span class="d-none d-md-inline">Add to Cart</span></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box-aside box-aside--dark">
                <div class="add-to-cart add-to-cart--column">
                    <div class="add-to-cart__price">
                        <div class="add-to-cart__price-discount" data-tooltip v-if="priceRules?.length">
                            BUY MORE AND SAVE <i class="icon-help-circle"></i>

                            <div class="tooltip tooltip--top">
                                <div class="tooltip-inner tooltip-inner--md">
                                    <div class="tooltip-headline">BUY MORE AND SAVE</div>

                                    <ul>
                                        <li v-for="(rule, index) in priceRules" :key="index">
                                            When you buy <strong>at least {{rule.min}}&nbsp;licenses</strong>, you get a <strong>{{rule.format}}&nbsp;discount</strong>, reducing the price per license to <strong>{{rule.finalPrice.toFixed(2)}}&nbsp;EUR</strong> (instead of {{rule.originalPrice}}&nbsp;EUR).
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="add-to-cart__price-value">
                            {{ formFinalPrice }}
                        </div>

                        <div class="add-to-cart__price-info">per license, VAT incl.</div>

                        <div class="add-to-cart__price-value-original" v-if="formOriginalPrice">
                            {{ formOriginalPrice }}
                        </div>

                        <div class="add-to-cart__price-badge" v-if="formRuleFormat">
                            <span class="badge rounded-pill text-bg-secondary">save {{ formRuleFormat }}</span>
                        </div>
                    </div>

                  <div class="add-to-cart__action widget-quantity">
                    <div class="add-to-cart__quantity">
                        <select v-model.number.lazy="formQuantity"
                                v-if="formQuantity <= maxPredefinedQuantity"
                                aria-label="Quantity">
                            <option v-for="quantity in predefinedQuantities" :value="quantity.value">{{ quantity.label }}</option>
                        </select>
                        <input type="number"
                               v-model.number.lazy="formQuantity"
                               @blur="normalizeQuantityInput($event.target)"
                               min="1"
                               class="form-control"
                               aria-label="Quantity"
                               v-else>
                    </div>

                    <button class="add-to-cart__button btn btn-primary" @click="onProductAdd(this.$config.id)"><span>Add to Cart</span></button>
                  </div>

                    <div class="add-to-cart__content">
                        <ul class="list-icon-check-circle-closed" v-if="this.$config.supportPeriod">
                            <li>14-day money-back guarantee</li>
                            <li>Free future updates</li>
                            <li>{{ this.$config.supportPeriod }} months of support</li>
                            <li>Includes Veello Portfolio<br><strong>Save 69.00 EUR</strong></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="payments-method">
                <div class="payments-method__headline">Secure payments</div>

                <div class="payments-method__list">
                    <img :src="this.$config.paymentLogoStripe" alt="Stripe" width="58" height="24">
                    <img :src="this.$config.paymentLogoPaypal" alt="PayPal" width="90" height="24">
                </div>
            </div>
        </div>

        <Modal v-model="showModal" v-if="product !== null" cssClass="product-cart" @close="onModalClose" id="modal-product-cart">
            <template v-slot:alert>
                <div class="alert alert-success">
                    <p>The product has been added to your shopping cart.</p>
                </div>
            </template>

            <template v-slot:body>
                <div class="cart-modal">
                    <div class="cart-modal__main">
                        <template v-if="loading">
                            <Loading :css-class="'loading--cover'"></Loading>
                        </template>

                        <div class="cart-modal__product">
                            <div class="cart-modal__product-row">
                                <div class="flex-grow-1">
                                    <div class="cart-modal__product-name">
                                        <div v-if="modalRuleFormat" class="cart-modal__product-name-badge">
                                            <span class="badge badge-md badge-pill badge-extra-light">save {{ modalRuleFormat }}</span>
                                        </div>
                                        {{ product.name }}
                                    </div>
                                    <div class="cart-modal__product-quantity">
                                        {{ modalQuantity }} Licenses
                                    </div>
                                </div>

                                <div class="cart-modal__quantity-field">
                                    <select :value="modalQuantity"
                                            @change="onProductQuantityUpdate($event.target.value)"
                                            v-if="modalQuantity <= maxPredefinedQuantity"
                                            aria-label="Quantity">
                                        <option v-for="quantity in predefinedQuantities" :value="quantity.value" :selected="modalQuantity === quantity.value">
                                            {{ quantity.label }}
                                        </option>
                                    </select>
                                    <input type="number"
                                           :value="modalQuantity"
                                           min="1"
                                           class="form-control"
                                           @change="onProductQuantityUpdate($event.target.value)"
                                           @blur="normalizeQuantityInput($event.target)"
                                           aria-label="Quantity"
                                           v-else>
                                </div>

                                <div class="ms-auto">
                                    <div class="product-price product-price--block product-price--lg">
                                        <div class="product-price__text" v-if="modalQuantity > 1">
                                            {{ modalUnitPrice }} / license
                                        </div>
                                        <div class="product-price__value">
                                            {{ modalTotalPrice }}
                                        </div>
                                        <div class="product-price__text">
                                            (VAT incl.)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                       <div class="quantity-selection">
                            <div class="cart-modal__headline">Buy More Pay Less</div>

                           <div class="quantity-selection__list">
                               <button type="button" class="quantity-selection__btn" v-for="(rule, index) in priceRules" :key="index"
                                       :class="modalQuantity >= rule.min && (rule.max === null || modalQuantity <= rule.max) ? 'selected' : ''"
                                       :disabled="modalQuantity >= rule.min && (rule.max === null || modalQuantity <= rule.max)"
                                       @click="onProductQuantityUpdate(rule.min)">
                                   <span class="badge badge-md rounded-pill text-bg-secondary">{{rule.format}}&nbsp;discount</span>

                                   <div class="quantity-selection__price">
                                       <span class="quantity-selection__price-value">Buy {{rule.min}}+</span>
                                       <span class="quantity-selection__price-text"> license</span>
                                   </div>

                                   <div class="quantity-selection__price">
                                       <span class="quantity-selection__price-value">Pay {{rule.finalPrice.toFixed(2)}} EUR</span>
                                       <span class="quantity-selection__price-text">/ license</span>
                                   </div>
                               </button>
                           </div>
                        </div>

                        <div class="cart-modal__buttons-group buttons-group buttons-group--no-wrap">
                            <button type="button" class="btn btn-secondary btn-icon" @click="showModal = false"><span class="d-none d-xl-inline">Continue Shopping</span><span class="d-xl-none">Back</span> <i class="icon icon-chevron-left"></i></button>
                            <a :href="this.$config.checkoutUrl" class="btn btn-primary btn-icon" title="Checkout">Checkout <i class="icon icon-shopping-bag"></i></a>
                        </div>
                    </div>
                    <div class="cart-modal__services" v-if="services.length > 0">
                        <div class="cart-modal__headline">Additional Services</div>
                        <div class="cart-modal__services-list">
                            <div class="cart-modal__service" v-for="service in services">
                                <div class="cart-modal__service-inside">
                                    <div class="cart-modal__service-image" v-if="service.icon" v-html="`<i data-icon='&#x${service.icon};'></i>`"></div>
                                    <div class="cart-modal__service-image" v-else-if="service.image">
                                        <img :src="service.image" alt="">
                                    </div>
                                    <div class="cart-modal__service-row">
                                        <div>
                                            <div class="cart-modal__service-name">{{ service.name }}</div>
                                        </div>
                                        <div class="cart-modal__service-price">
                                            <div class="product-price product-price--cart-modal-service">
                                                <div class="product-price__value">{{ service.price }}</div>
                                                <div class="product-price__text">(VAT incl.)</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cart-modal__service-buttons">
                                        <button class="cart-modal__service-buttons-info btn btn-secondary btn-one-icon btn-one-icon--md rounded-circle" :content="service.teaser" v-if="service.teaser" v-tippy="{ placement : 'bottom', maxWidth : 260, allowHTML: true }" :aria-label="`More info about ${service.name}`">
                                            <i class="icon icon-info" aria-hidden="true"></i>
                                        </button>
                                        <button @click="onServiceRemove(service)"
                                                class="btn btn-primary btn-one-icon btn-one-icon--md rounded-circle" :disabled="loadingServiceId" v-if="service.quantity > 0" :aria-label="`Remove ${service.name} from cart`">
                                            <i class="icon" :class="loadingServiceId === service.id ? 'spinner-border spinner-border-sm' : 'icon-x'" aria-hidden="true"></i>
                                        </button>
                                        <button @click="onServiceAdd(service)"
                                                class="btn btn-primary btn-one-icon btn-one-icon--md rounded-circle" :disabled="loadingServiceId" v-else :aria-label="`Add ${service.name} to cart`">
                                            <i class="icon" :class="loadingServiceId === service.id ? 'spinner-border spinner-border-sm' : 'icon-shopping-bag'" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Loading from '../../../_components/Loading';
    import Modal from '../../../_components/Modal';
    import ReadingProgressBar from '../../../_components/ReadingProgressBar.vue';
    import { cartObserver } from '../../../_helpers/cart-observer';
    import {httpClient} from '../../../_helpers/http-client';
    import SectionNavigation from '../../../_components/SectionNavigation.vue';

    export default {
        components: {
            SectionNavigation,
            ReadingProgressBar,
            Loading,
            Modal,
        },
        data() {
            return {
                loading: false,
                loadingServiceId: null,
                product: null,
                maxPredefinedQuantity: 5,
                formQuantity: 1,
                modalQuantity: 1,
                showModal: false,
                services: [],
            };
        },
        computed: {
            predefinedQuantities() {
                const quantities = [];

                for (let i = 1; i <= this.maxPredefinedQuantity; i++) {
                    quantities.push({ value: i, label: i });
                }

                quantities.push({
                    value: this.maxPredefinedQuantity + 1,
                    label: `${this.maxPredefinedQuantity + 1}+`,
                });

                return quantities;
            },
            modalRuleFormat() {
                return this.getPriceRule(this.modalQuantity)?.format;
            },
            modalUnitPrice() {
                return this.formatPrice(this.getFinalPrice(this.modalQuantity));
            },
            modalTotalPrice() {
                return this.formatPrice(this.getFinalPrice(this.modalQuantity) * this.modalQuantity);
            },
            navigation() {
                return this.$config.navigation ?? [];
            },
            priceRules() {
                return this.$config.priceRules ?? [];
            },
            formFinalPrice() {
                if (this.$config.view === 'button') {
                    return null;
                }

                return this.formatPrice(this.getFinalPrice(this.formQuantity));
            },
            formOriginalPrice() {
                const originalPrice = this.getUnitPrice(1);
                const discountPrice = this.getUnitPrice(this.formQuantity);

                if (originalPrice === discountPrice) {
                    return '';
                }

                return this.formatPrice(originalPrice);
            },
            formRuleFormat() {
                if (this.$config.view === 'button') {
                    return null;
                }

                return this.getPriceRule(this.formQuantity)?.format;
            }
        },
        methods: {
            formatPrice(price) {
                return price ? `${price.toFixed(2)} EUR` : '';
            },
            getUnitPrice(quantity) {
                return this.getPriceRule(quantity)?.finalPrice || this.$config.priceRaw;
            },
            getFinalPrice(quantity) {
                return this.getUnitPrice(quantity);
            },
            getPriceRule(quantity) {
                return this.$config.priceRules.find(rule => rule.min <= quantity && (rule.max === null || rule.max >= quantity));
            },
            normalizeQuantityInput(target) {
                const value = target.value.trim();
                const numValue = parseInt(value, 10);

                if (isNaN(numValue) || numValue < 1 || value === '') {
                    target.value = '1';
                    target.dispatchEvent(new Event('change'));
                }
            },
            onModalClose() {
                this.product = null;
                this.formQuantity = 1;
                this.modalQuantity = 1;
            },
            onProductAdd(product) {
                this.loading = true;

                httpClient.post(this.$config.addProductUrl, { product, quantity: this.formQuantity, services: true }).then(response => {
                    this.product = response.data.product;
                    this.services = response.data.services || [];
                    this.modalQuantity = this.formQuantity;
                    this.showModal = true;

                    cartObserver.update(this);
                }).finally(() => this.loading = false);
            },
            onProductQuantityUpdate(quantity) {
                const newQuantity = parseInt(quantity, 10);
                const previousQuantity = this.modalQuantity;
                const quantityDifference = newQuantity - previousQuantity;

                if (quantityDifference === 0) return;

                this.modalQuantity = newQuantity;
                this.loading = true;

                httpClient.post(this.$config.updateProductUrl, {
                    product: this.$config.id,
                    quantity: quantityDifference,
                }).then(() => cartObserver.update(this)).finally(() => this.loading = false);
            },
            onServiceAdd(product) {
                this.loadingServiceId = product.id;
                this.services.find(service => service.id === product.id).quantity = 1;

                httpClient.post(this.$config.addProductUrl, { product: product.id, quantity: 1 })
                    .then(() => cartObserver.update(this))
                    .finally(() => this.loadingServiceId = null)
                ;
            },
            onServiceRemove(product) {
                this.loadingServiceId = product.id;
                this.services.find(service => service.id === product.id).quantity = 0;

                httpClient.post(this.$config.updateProductUrl, { product: product.id, quantity: -1 })
                    .then(() => cartObserver.update(this))
                    .finally(() => this.loadingServiceId = null)
                ;
            },
        },
    }
</script>
